module.exports = __webpack_public_path__ + "img/65.f67f41ef.jpg";